module.exports = __webpack_public_path__ + "img/mobile-35.cb7fb04b.png";